import 'jquery-lazyload';

if ($().lazyload) {
    $('img[data-original], div[data-original]').lazyload({
        threshold: 200
    });
}

window.addEventListener('DOMContentLoaded', () => {
    const lazyLoadImages = document.querySelectorAll(".lazy");
    if ("IntersectionObserver" in window) {
        const imageObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const image = entry.target;
                    image.classList.remove('lazy');
                    imageObserver.unobserve(image);
                }
            });
        });

        lazyLoadImages.forEach((image) => {
            imageObserver.observe(image);
        });
    }
});
